/**
 * @enum MARKETING_MATERIAL_TYPE
 * @type {{ONBOARDING_FLYER: string, WEDDING_TABLE_TENT: string, ONBOARDING_SOCIAL: string, QR_CODE_SHARE: string, PROFILE_PAGE_SOCIAL: string, WEDDING_FLYER: string, WEDDING_FLYER_VIDEO_GUESTBOOK: string, SHUTTERBUG_FLYER: string, SHUTTERBUG_TABLE_TENT: string}}
 */
export const MARKETING_MATERIAL_TYPE = {
  ONBOARDING_SOCIAL: 'ONBOARDING_SOCIAL',
  ONBOARDING_FLYER: 'ONBOARDING_FLYER',
  PROFILE_PAGE_SOCIAL: 'PROFILE_PAGE_SOCIAL',
  WEDDING_FLYER: 'WEDDING_FLYER',
  WEDDING_TABLE_TENT: 'WEDDING_TABLE_TENT',
  WEDDING_FLYER_VIDEO_GUESTBOOK: 'WEDDING_FLYER_VIDEO_GUESTBOOK',
  SHUTTERBUG_FLYER: 'SHUTTERBUG_FLYER',
  SHUTTERBUG_TABLE_TENT: 'SHUTTERBUG_TABLE_TENT',
  QR_CODE_SHARE: 'QR_CODE_SHARE',
};
